import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
  get_award_event_list_action,
  awardEvent_delete_action,
} from "../../../actions/adminModule_action/awardEvent_action";
import { responseError } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";

class AwardEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user_id: "",
      award_event_id: "",
      award_event_name: "",
      is_active: "Active",
      AwardEventList: [],
      isAccordionExpanded: false,
      currentPage: 1,
    };
    this.updateItem = this.updateItem.bind(this);
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);

    this.setState({
      user_id: sessionStorage.getItem("user_id") || "",
    });
    this.getAwardEventList();
  }

  getAwardEventList = () => {
    const { award_event_name, is_active } = this.state;
    this.setState({ isLoading: true });
    this.props
      .get_award_event_list_action(award_event_name, is_active === 'Active' ? 1 : 0)
      .then((data) => {
        if (data.error !== 1) {
          this.setState({
            AwardEventList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          this.setState({ isLoading: false });
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  };

  handleDelete = (award_event_id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Jury?"
    );
    if (confirmed) {
      this.props
        .awardEvent_delete_action(award_event_id)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getAwardEventList();
          } else {
            responseError(data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  navigateAwardAdd = () => {
    this.props.navigate("/awardEventDetail");
  };

  navigateAwardUpdate = (award_event_id) => {

    this.props.navigate(`/awardEventDetail`, {
      state: { award_event_id: award_event_id },
    });
  };

  clearFilters = () => {
    this.setState({ award_event_name: "", is_active: 'Active' },
      () => { this.getAwardEventList() });
  };

  updateItem = (item) => {
    this.setState({ currentPage: item });
  };
  awardEventRecord(AwardEventList) {
    return (
      <table class="table table-bordered" id="dashboard-table">
        <thead>
          <tr>
            <th style={{ width: "25%" }}>Award Event Name</th>
            <th style={{ width: "25%" }}>Award Event Period</th>
            <th style={{ width: "25%" }}>Description</th>
            <th style={{ width: "15%" }}>Status</th>
            <th className="text-right" style={{ width: "4%" }}>
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {AwardEventList.length > 0 ? (
            AwardEventList.map((data) => (
              <tr>
                <td>{data.award_event_name}</td>
                <td>{data.awardEvent_period}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer",
                  }}
                  title={data.award_event_description}
                >
                  {data.award_event_description}
                </td>
                <td>{data.is_active == 1 ? "Active" : "In-Active"}</td>
                <td className="text-right">
                  <a
                    href="javascript:void(0);"
                    title="Edit"
                    className="btn btn-sm"
                    onClick={() => this.navigateAwardUpdate(data.award_event_id)}
                  >
                    <i class="fa fa-pencil-square-o text-primary"></i>
                  </a>
                  {data.is_active != 1 ? <></> : <>
                    <a
                      title="Delete"
                      className="btn btn-sm delete_record ml-2"
                      onClick={() => this.handleDelete(data.award_event_id)}
                    >
                      <i class="ri-delete-bin-line text-danger"></i>
                    </a>
                  </>}
                </td>
              </tr>
            ))
          ) : (
            <td colSpan={4} className="text-center">
              No records found
            </td>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    const {
      isLoading,
      AwardEventList,
      currentPage,
      isAccordionExpanded,
      award_event_name, is_active,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = AwardEventList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(AwardEventList.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">

            <div className="website-view">
              <Header data={[8]} />
            </div>
            <div className="mobile-view">
              <MobileHeader data={[8]} />
            </div>
            <section class='header_margin_top'>
              <div className="container-fluid">
                <div className="page-header">
                  <h2 class="mb-1 dashboard-tit  py-0 blog-name">Award Event List</h2>
                  <button className="btn btn-outline-primary" onClick={() => this.navigateAwardAdd()}>Add</button>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          {award_event_name ? <>
                            <h5>
                              <b>Award Name :</b>{" "}
                              <span>{award_event_name}</span>
                            </h5>
                          </> : <></>}
                          {is_active ? <>
                            <h5>
                              <b>Status :</b>{" "}
                              <span>{is_active}</span>
                            </h5>
                          </> : <></>}
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                          }`}
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2 ml-4">
                              <div className="row">
                                <label>Name</label>
                                <input
                                  type="text"
                                  className="form-control border-input"
                                  placeholder="Enter Name"
                                  value={award_event_name}
                                  onChange={(e) =>
                                    this.setState({
                                      award_event_name: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-select"
                                  value={is_active}
                                  onChange={(e) => {
                                    this.setState({
                                      is_active: e.target.value,
                                    });
                                  }}
                                >
                                  <option key='Active' value="Active">Active</option>
                                  <option key='InActive' value="InActive">In-Active</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-md-4 mt-4">
                              <button
                                onClick={() => this.getAwardEventList()}
                                className="btn btn-outline-primary  rounded-1"
                              >
                                Search
                              </button>
                              &nbsp;
                              <button
                                onClick={() => this.clearFilters()}
                                className="btn btn-outline-danger  rounded-1"
                              >
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.awardEventRecord(currentRecords)}
                      {AwardEventList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <Footer />
          <ToastContainer />
        </>
      </>
    );
  }
}
const mapDispatchToProps = {
  get_award_event_list_action,
  awardEvent_delete_action,
};

export default withRouter(connect(null, mapDispatchToProps)(AwardEvent));
